import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { Box } from '@material-ui/core'

import { Flexbox, Logo, NavLink, Text } from '~/components/shared'

import { AppState } from '~/state/store'

import ROUTES from '~/constants/routes'

import msg from './footer.mesagess'
import { useMobileStyles } from './Footer.styles'

const FooterMobile: React.FC = () => {
  const s = useMobileStyles()
  const uiSettings = useSelector((state: AppState) => state.user?.ui_setting)

  return (
    <footer className={s.root}>
      <Flexbox className={s.content}>
        <Logo
          className={s.logo}
          src={uiSettings?.logo_link}
          width={uiSettings?.logo_width}
        />

        <Box className={s.copyrightWrapper}>
          <NavLink href={ROUTES.privacy}>
            <FormattedMessage {...msg.privacy} />
          </NavLink>

          <NavLink href={ROUTES.terms}>
            <FormattedMessage {...msg.terms} />
          </NavLink>
        </Box>
      </Flexbox>

      <Text className={s.text}>
        <FormattedMessage
          {...msg.rightsReserved}
          values={{ year: new Date().getFullYear() }}
        />
      </Text>
    </footer>
  )
}

export default FooterMobile
